// removed by extract-text-webpack-plugin
module.exports = {"container":"R1f6VsXg3gcbpwOs1lsvs","title":"_3tonAItsrzMB6OyMVJDCil","buttons":"rUX096xtrcYlBwk04RXOp","cancelButton":"_3gePF5R3VjabJWiZCJX55H"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Root/ApolloError/VerifyEmail/Verify/styles.css
// module id = 1020
// module chunks = 21